import React from 'react';
import { Container } from '@autopylot-internal/dependency-injection';

interface IContainerContext {
    container: Container | null
}

export const DependencyContainerReactContext = React.createContext<IContainerContext>({ container: null });
